module.exports = __webpack_public_path__ + "static/media/med.0d0525a3.png";